import { defineStore } from 'pinia'
import { ref } from 'vue'
import { readCsrf } from '@/utils'

export const useUiHelpers = defineStore('uiHelpers', () => {
  const loading = ref<boolean>(false)
  const csrfToken = ref<string>(readCsrf())

  function apiError() {
    alert(
      "We're sorry, something went wrong with that request. Please refresh the page and try again. If this does not work, please contact us at info@stadiamaps.com.",
    )
  }

  function cardError(reason: string) {
    alert(
      `We're sorry, but we encountered an error charging your card: ${reason}\n\nPlease try again. If this does not work, contact your bank or email us at info@stadiamaps.com for more information.`,
    )
  }

  async function runAsyncFunction<T>(fn: () => Promise<T>): Promise<T> {
    loading.value = true
    try {
      return await fn()
    } catch (e) {
      apiError()
      throw e
    } finally {
      loading.value = false
    }
  }

  return { loading, csrfToken, apiError, cardError, runAsyncFunction }
})
